const classes = {
	title: "Classes",
	new_classes: "New Class",
	edit_classes: "Edit Class: {name}",
	view_classes: "View Class: {name}",
	list_title: "List of Classes",
	list_subtitle: "Manage Classes",
	create_title: "Create Class",
	update_title: "Update Class",
	details_title: "Class Details",
	id: "ID",
	name: "Name",
	active: "Active",
	inactive: "Inactive",
	duration: "Duration",
	status: "Status",
	duration_type: "Type",
	min: "Min",
	hours: "Hours",
	coursetype_id: "Course Type",
	coursetypegroup_id: "Course Type Group",
};
export default classes;